import "./embed.css";
import createEmbed from "./create-embed";
import createFallback from "./create-fallback";
import experienceSupported from "./experience-supported";

(function embedExperience() {
  if (!experienceSupported()) {
    document.addEventListener("DOMContentLoaded", createFallback);
    return;
  }

  document.addEventListener("DOMContentLoaded", createEmbed);
})();
